/**
 * The supplied compact mark's geometry (public/brand/play/mark.svg) with the theme's colours: four rounded layers,
 * bottom to top, each outlined in ink, and the play triangle on the top layer. `PlayLogo` draws it still and
 * `WarmUpMark` lets its layers move; both read it from here, so they can't drift apart.
 */
export const MARK_VIEWBOX = '0 0 48 48'
export const MARK_STROKE_WIDTH = 1.5
export const MARK_LAYER_SIZE = 31
export const MARK_LAYER_RADIUS = 8
export const MARK_TRIANGLE = 'm26 10 11 7.5L26 25z'

/** The layers bottom to top: yellow, pink, green, then the white face that carries the triangle. */
export const MARK_LAYERS = [
  { x: 2, y: 14, fill: 'var(--play-action)' },
  { x: 6, y: 10, fill: 'var(--play-selected)' },
  { x: 10, y: 6, fill: 'var(--play-live)' },
  { x: 14, y: 2, fill: 'var(--play-canvas)' },
] as const
